export const prettyDecimal = (value: number | string) =>
    parseFloat(String(value)).toFixed(2);
